import * as React from 'react';
import SettingPopup from '../common/SettingPopup';
import { REVISION, PLATFORM } from '../../../../../common/src/ts/defines';
import { createDateTimeString } from '../../utils/string';

export interface SystemInformationProps {
  isOpen: boolean;
  onClose: () => void;
}

export interface SystemInformationState {
  date: string;
}

export class SystemInformation extends React.Component<
  SystemInformationProps, SystemInformationState
  > {
  private systemInformation: HTMLUListElement | null = null;
  private updateDateIntervalID: number | null = null;

  public constructor(props: SystemInformationProps) {
    super(props);
    this.state = {
      date: createDateTimeString(),
    };
  }

  private handleClick = () => {
    if (
      this.systemInformation !== null &&
      this.systemInformation.textContent !== null
    ) {
      const textarea = document.createElement('textarea');
      document.body.appendChild(textarea);
      textarea.value = this.systemInformation.textContent;
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
  }

  public componentDidMount() {
    this.updateDateIntervalID = window.setInterval(
      () => this.setState({ date: createDateTimeString() }),
      1000,
    );
  }

  public componentWillUnmount() {
    if (this.updateDateIntervalID) {
      window.clearInterval(this.updateDateIntervalID);
    }
  }

  public render() {
    if (!this.props.isOpen) {
      return null;
    }

    const items = [
      { name: 'revision', value: REVISION },
      { name: 'platform', value: PLATFORM },
      { name: 'userAgent', value: window.navigator.userAgent },
    ];
    if (PLATFORM !== 'electron') {
      items.push({ name: 'url', value: window.location.href });
    }
    items.push({ name: 'date', value: this.state.date });

    const liStyle: Readonly<React.CSSProperties> = {
      paddingBottom: '1em',
    };

    const list = items.map((item) => {
      return <li key={item.name} style={liStyle}>{item.name}: {item.value} </li>;
    });

    const ulStyle: Readonly<React.CSSProperties> = {
      width: '400px',
      height: '300px',
      overflow: 'auto',
      paddingRight: '1em',
    };

    const copyButtonStyle: Readonly<React.CSSProperties> = {
      position: 'absolute',
      bottom: '1em',
      right: '1em',
    };

    return (
      <SettingPopup title="システム情報" onClose={this.props.onClose}>
        <ul ref={el => this.systemInformation = el} style={ulStyle}>
          {list}
        </ul>
        <button onClick={this.handleClick} style={copyButtonStyle}>クリップボードへコピー</button>
      </SettingPopup>
    );
  }
}
